export const types = {
  CHECK_PROJECT_NAME: "CHECK_PROJECT_NAME",
  CHECK_NEW_PROJECT_CASE_NAME: "CHECK_NEW_PROJECT_CASE_NAME",
  CHECK_PROJECT_DESCRIPTION: "CHECK_PROJECT_DESCRIPTION",
  CHECK_PROJECT_PICTURE: "CHECK_PROJECT_PICTURE",
  CHECK_EXISTING_PROJECT_CASE_NAME: "CHECK_EXISTING_PROJECT_CASE_NAME",
  CHECK_CASE_DESCRIPTION: "CHECK_CASE_DESCRIPTION",
};
